const ertigaSliders = [
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Red.jpg',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Red.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ertiga.jpg',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ertiga.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ertiga+1.jpg',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ertiga+1.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Smart+Infotainment.jpg',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Smart+Infotainment.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Exterior+5.jpg',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Exterior+5.jpg',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Dashboard.jpg',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Dashboard.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Airbags.jpg',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Airbags.jpg',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ac+Ventts.jpg',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Ac+Ventts.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Side+Mirror.jpg',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/Side+Mirror.jpg',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/AC.jpg',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/AC.jpg',
  },
];

const ertigaColors = [
  {
    id: 1,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/RED.webp',
  },
  {
    id: 2,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/artic-white.webp',
  },
  {
    id: 3,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/magma-grey.webp',
  },
  {
    id: 4,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/prime-oxford-blue.webp',
  },
  {
    id: 5,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/silky-silver.webp',
  },
  {
    id: 6,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-ertiga/colors/dignity_brown.webp',
  },
  {
    id: 7,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/ertiga/ertiga-black.webp',
  },
];

const ertigaVariants = [
  {
    id: 1,
    title: 'lxi (o)',
    transmission: 'manual',
    mileage: '20.51 ',
    price: '₹ 8,84,000 Lakh',
  },
  // {
  //   id: 2,
  //   title: "new ertiga vxi",
  //   transmission: "manual",
  //   mileage: "20.30 ",
  //   price: "9.49",
  // },
  {
    id: 3,
    title: 'vxi (o)',
    transmission: 'manual',
    mileage: '20.30 ',
    price: '₹ 9,93,000 Lakh',
  },

  {
    id: 5,
    title: 'zxi (o)',
    transmission: 'manual',
    mileage: '20.30 ',
    price: '₹ 11,03,000 Lakh',
  },
  {
    id: 6,
    title: 'zxi+',
    transmission: 'manual',
    mileage: '20.30 ',
    price: '₹ 11,73,000 Lakh',
  },
  {
    id: 7,
    title: 'vxi at',
    transmission: 'automatic',
    mileage: '20.30 ',
    price: '₹ 11,33,000 Lakh',
  },
  {
    id: 8,
    title: 'zxi at',
    transmission: 'automatic',
    mileage: '20.30 ',
    price: '₹ 12,43,000 Lakh',
  },
  {
    id: 9,
    title: 'zxi+ at',
    transmission: 'automatic',
    mileage: '20.51 ',
    price: '₹ 13,13,000 Lakh',
  },
  // {
  //   id: 10,
  //   title: 'new ertiga vxi cng',
  //   transmission: 'manual',
  //   mileage: '26.11 ',
  //   price: '10.44',
  // },
  {
    id: 11,
    title: 'vxi (o) cng',
    transmission: 'manual',
    mileage: '26.11 ',
    price: '₹ 10,88,000 Lakh',
  },
  // {
  //   id: 12,
  //   title: 'new ertiga zxi cng',
  //   transmission: 'manual',
  //   mileage: '26.11 ',
  //   price: '11.54',
  // },
  {
    id: 13,
    title: 'zxi (o) cng',
    transmission: 'manual',
    mileage: '26.11 ',
    price: '₹ 11,98,000 Lakh',
  },
  // {
  //   id: 14,
  //   title: 'ertiga tour m petrol',
  //   transmission: 'manual',
  //   mileage: '18.04 ',
  //   price: '9.60',
  // },
  {
    id: 14,
    title: 'tour m (o) (p)',
    transmission: 'manual',
    mileage: '18.04 ',
    price: '₹ 9,90,000 Lakh',
  },
  // {
  //   id: 15,
  //   title: 'ertiga tour m cng',
  //   transmission: 'manual',
  //   mileage: '26.08 ',
  //   price: '10.41',
  // },
  {
    id: 16,
    title: 'tour m (o) cng',
    transmission: 'manual',
    mileage: '26.08 ',
    price: '₹ 10,85,000 Lakh',
  },
  {
    id: 17,
    title: '',
    transmission: '',
    mileage: ' ',
    price: '',
  },
];

const ertigaMileage = [
  {
    id: 1,
    fueltype: 'petrol',
    transmission: 'manual',
    mileage: '20.51 KM/L',
  },
  {
    id: 2,
    fueltype: 'petrol',
    transmission: 'automatic',
    mileage: '20.30 KM/L',
  },
  {
    id: 3,
    fueltype: 'cng',
    transmission: 'manual',
    mileage: '26.11 KM/KG',
  },
];



const ertigaData = {
  name: "Ertiga",
  brand: "Maruti Suzuki",
  priceRange: "₹ 8.84 - 13.13 Lakhs*",
  specs: [
    { label: "Engine", value: "1462 CC",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/speedometer.png",  },
    { label: "Mileage", value: "26.11 km/kg*",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/gas-station.png", },
    { label: "Power (KW)", value: "75.8" ,icon : "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/car.png", },
  ],
  iconUrls: [
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/AGS.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/S-CNG_mimimum+black.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/K-SERIES.webp",
  ],
  brochureLink:
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/brochures/Saboo_RKS_Ertiga_Brochure.pdf",
  compareLink: "/compare-cars",
  cngLink: "/maruti-ertiga-cng-on-road-price-in-hyderabad",
};
export { ertigaSliders, ertigaColors, ertigaVariants, ertigaMileage,ertigaData };
